export default {
  viewBox: "0 0 24 24",
  html: "<path fill=\"currentColor\" d=\"M13.68 9v6h3l-4 4-4-4h3V9h-3l4-4 4 4zm-9-7h16v2h-16zm0 18h16v2h-16z\"/>"
};